import React, { FC } from "react";
import { Row } from "reactstrap";

export const TabList: FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
}): JSX.Element => {
  return <Row className={className || ""}>{children}</Row>;
};
